angular
	.module 'App.Directive'
	.directive 'generatableInput', ->
		require: 'ngModel',
		scope:
			value: '=ngModel'
			isNewEntity: '='
			isReadOnly: '=?'
			labelText: '@?'
			placeholderText: '@?'
			smallStyle: '=?'
			maxValueLength: '=?'
			autoGenerateEnabled: '=?'
			generatorCallback: '&?'
			validationEnabled: '=?'
			validationShowMessage: '=?'
		templateUrl: '@directive/input/generatable-input/generatable-input.view.html'
		controller: 'GeneratableInputController'
		controllerAs: 'generatableInput'
		bindToController: true

class GeneratableInputController extends BaseController
	@register angular.module 'App.Directive'
	@inject 'ToastService',
		'translate'

	initialize: ->
		@maxValueLength ?= 64
		@autoGenerateEnabled ?= true

		@initializeValidation()

		if @autoGenerateEnabled && !@value?
			@generate()

	onCopy: ->
		@ToastService.add(
			null,
			@labelText,
			@translate('general.copied.to.clipboard'),
			'success'
		)

	initializeValidation: ->
		@validationEnabled ?= true
		@validationShowMessage ?= @validationEnabled

		if !@validationEnabled
			@validationRegex = new RegExp('')
			return

		# Pattern should match backend validation in IdentifierAllowedCharactersValidator::ALLOWED_CHARACTERS_REGEX
		# Frontend additionally allows empty ID because then its generated in backend
		@validationRegex = new RegExp('^([a-z0-9]([a-z0-9\-_.]*[a-z0-9])?)?$', 'i')

		@isValid = true

	generate: ->
		@value = if @generatorCallback? then @generatorCallback() else @Guid.generate()
		@validate(@value)

	validate: (idValue) ->
		# Validation is duplicated (ng-pattern and this method) because:
		# - can't show error message based on ng-pattern validation
		# - can't set input element validity from custom validator

		if !@validationEnabled
			return

		# needed because idValue (as well as @value) is undefined if it doesn't
		# pass ng-pattern validation
		@inputElement ?= $('#generatable_input_' + @controllerId)[0]
		idValue ?= @inputElement.value

		@isValid = @validationRegex.test(idValue)
